import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Messages from "./pages/Messages";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Messages />} />
      </Routes>
    </Router>
  );
};

export default App;
